export default __webpack_public_path__ + "static/media/undraw_Camera_re_cnp4.6b34afdf.svg";